import React from "react"
import styled from "styled-components"
import { FetchSingleListingLocation } from "../../generated/graphql"
import Box from "../box"
import ReactMapboxGl, * as Mapbox from "react-mapbox-gl"
import "mapbox-gl/dist/mapbox-gl.css"
const Map = ReactMapboxGl({
  accessToken: process.env.REACT_APP_MAPBOX_API_KEY as string
}) as any

const DynmicMapImage = styled.div`
  min-height: 380px;
  width: 100%;
  background-size: cover;
  background-position: center center;
`
const HeadingH2 = styled.h2`
  text-decoration: none;
  margin-bottom: 18px;
  color: rgb(60, 66, 64);
  font-size: 32px;
  font-weight: 600;
`
const TagContainer = styled.div`
  display: inline-block;
  margin-right: 8px;
  margin-bottom: 8px;
`;

const Tag = styled.div`
  background-color: #ffffff;
  color: #3c4240;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 14px;
  border: 1px solid #c4c6c5;
  font-weight:600;
  height: 24px;
  justify-content: center;
  align-items: center;
  display: flex;
`;

const TagsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 8px;
`;

interface Props {
  location: FetchSingleListingLocation
}

function StaticMap(props: Props) {
  const { location } = props
  const tags = location.tags
  const lat = location.lat
  const lng = location.lng

  const cleanTags: { [key: string]: boolean } = {};
  for (const key in tags) {
    if (tags.hasOwnProperty(key) && key !== 'id' && key !== '__typename') {
      cleanTags[key] = tags[key];
    }
  }
  const getTagName = (tagKey: string): string => {
    switch (tagKey) {
      case "closeToTransit":
        return "Close to Transit";
      case "parksAndWater":
        return "Parklands";
      case "nightlife":
        return "Nightlife";
      case "purposeBuiltRentals":
        return "Purpose-built rentals";
      case "students":
        return "Students";
      case "luxuryRentals":
        return "Luxury Rentals";
      case "shortTermRentals":
        return "Short-term Rentals";
      case "professionallyManaged":
        return "Professionally Managed";
      case "onlinePayments":
        return "Online Payments";
      case "onlineApplications":
        return "Online Applications";
      case "furnishedRentals":
        return "Furnished Rentals";
      case "petFriendly":
        return "Pet-friendly";
      default:
        return "";
    }
  };
  return (
    <Box flexDirection="column" mb={[5]}>
      <HeadingH2 fontSize={[5]} color="black" fontWeight={600} mb={[3]}>
        Neighbourhood
      </HeadingH2>
      <Box mt={[2]}>
        <TagsRow>
          {cleanTags &&
            Object.entries(cleanTags).map(([tagKey, tagValue]) => {
              if (tagValue) {
                return (
                  <TagContainer key={tagKey}>
                    <Tag>{getTagName(tagKey)}</Tag>
                  </TagContainer>
                );
              }
              return null;
            })}
        </TagsRow>
      </Box>
      <Box flexDirection="column" mt={[2]}>
        <DynmicMapImage>
          <Map
            style={"mapbox://styles/mapbox/outdoors-v9"}
            containerStyle={{
              minHeight: "380px",
              width: "100%"
            }}
            center={[lng, lat]}
            zoom={[12]}
          >
            <Mapbox.Marker key={`listing-id-${location.id}`} coordinates={[lng, lat]}>
              <Mapbox.Layer layout={{ "icon-image": "marker-15" }}>
                <Mapbox.Feature coordinates={[lat, lng]} />
              </Mapbox.Layer>
            </Mapbox.Marker>
          </Map>
        </DynmicMapImage>
      </Box>
    </Box>
  )
}

export default StaticMap
